import { memo, PropsWithChildren, SVGProps, ComponentProps } from 'react';
import type { Ref } from 'react';
import { cn } from '@ifixit/ui/lib/utils';

type SVGCircleProps = {
   x: number;
   y: number;
   r: number;
} & SVGProps<SVGCircleElement>;

export const SVGCircle = memo(function SVGCircleInternal({
   x,
   y,
   r,
   className,
   ...props
}: SVGCircleProps) {
   return <circle cx={x} cy={y} r={r} className={cn(className)} {...props} />;
});

export type SVGGroupProps = SVGProps<SVGGElement> & { ref?: Ref<SVGGElement> };

// Forwarded for tippy:
// https://github.com/atomiks/tippy.js-react#component-children
export const SVGGroup = memo(function SVGGroup({ ref, className, ...props }: SVGGroupProps) {
   return <g className={cn(className)} {...props} ref={ref} />;
});

type SVGTextProps = PropsWithChildren<SVGProps<SVGTextElement>>;

export const SVGText = memo(function SVGTextInternal({
   className,
   children,
   ...props
}: SVGTextProps) {
   return (
      <text className={cn(className)} {...props}>
         {children}
      </text>
   );
});

export type SVGElementProps = ComponentProps<'svg'> & { ref?: Ref<SVGSVGElement> };

export const SVGElement = memo(function SVGElement({ ref, className, ...props }: SVGElementProps) {
   return <svg className={cn(className)} {...props} ref={ref} />;
});
